/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLayoutJustifyH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 22h-2v-3h-4V5h4V2h2zM18 7v10h2V7zM2 2h2v3h4v14H4v3H2zm2 5v10h2V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLayoutJustifyH as LayoutJustifyH };
